
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { getBranchRequest } from "@/sea/apis/BranchesService";
import { useRouter } from "vue-router";
import { I18nUtils } from "@/sea/utils/I18nUtils";
import LightAlert from "@/sea/components/alerts/LightAlert.vue";

export default defineComponent({
  name: "branch",
  components: { LightAlert },
  props: {
    id: Number,
  },
  setup(props) {
    const router = useRouter();

    const id = props.id ?? 0;
    const { errorRef, branchRef, getBranch } = getBranchRequest();
    const loadingRef = ref(false);

    const fetchBranch = async (id: number) => {
      loadingRef.value = true;
      await getBranch(id);
      loadingRef.value = false;
    };

    onMounted(async () => {
      setCurrentPageBreadcrumbs(
        "sea.pages.branch.title",
        ["sea.aside.categories.management.title", "sea.pages.branches.title"],
        ["", router.resolve({ name: "branches" }).path]
      );
      await fetchBranch(id);
    });

    return {
      I18nUtils,
      loadingRef,
      branchRef,
      errorRef,
    };
  },
});
